(function () {
'use strict';
var D = window.Delume || {};
var $ = function (s, c) { return (c || document).querySelector(s); };
var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
function formatMoney(cents) {
var fmt = D.moneyFormat || '£{{amount}}';
cents = typeof cents === 'string' ? cents.replace('.', '') : cents;
function fmtNum(n, dec, thou, decSep) {
var num = (n / 100).toFixed(dec).split('.');
var whole = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
return whole + (num[1] ? decSep + num[1] : '');
}
var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
var val;
switch (m ? m[1] : 'amount') {
case 'amount_no_decimals': val = fmtNum(cents, 0, ',', '.'); break;
case 'amount_with_comma_separator': val = fmtNum(cents, 2, '.', ','); break;
case 'amount_no_decimals_with_comma_separator': val = fmtNum(cents, 0, '.', ','); break;
default: val = fmtNum(cents, 2, ',', '.');
}
return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
}
var toastEl;
function toast(msg) {
if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
toastEl.textContent = msg;
toastEl.classList.add('is-visible');
clearTimeout(toastEl._t);
toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
}
function setHeaderH() {
var h = $('.section-header');
if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
}
window.addEventListener('resize', setHeaderH);
document.addEventListener('DOMContentLoaded', setHeaderH);
var lastFocus = null;
function openDrawer(el) {
if (!el) return;
lastFocus = document.activeElement;
el.classList.add('is-open');
el.setAttribute('aria-hidden', 'false');
document.body.classList.add('is-locked');
$$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
var panel = $('.drawer__panel', el);
if (panel) setTimeout(function () { panel.focus(); }, 50);
}
function closeDrawer(el) {
if (!el || !el.classList.contains('is-open')) return;
el.classList.remove('is-open');
el.setAttribute('aria-hidden', 'true');
if (!$('.drawer.is-open') && !$('.search-modal.is-open')) document.body.classList.remove('is-locked');
$$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
if (lastFocus && lastFocus.focus) lastFocus.focus();
}
document.addEventListener('click', function (e) {
var opener = e.target.closest('[data-drawer-open]');
if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
var closer = e.target.closest('[data-drawer-close]');
if (closer) { closeDrawer(closer.closest('.drawer')); return; }
var cartOpen = e.target.closest('[data-cart-open]');
if (cartOpen && $('#CartDrawer') && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer($('#CartDrawer')); }
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); closeSearch(); }
});
var searchModal = null;
function openSearch() {
searchModal = searchModal || $('[data-search-modal]');
if (!searchModal) return;
lastFocus = document.activeElement;
searchModal.classList.add('is-open');
searchModal.setAttribute('aria-hidden', 'false');
document.body.classList.add('is-locked');
setTimeout(function () { var i = $('[data-predictive-input]', searchModal); if (i) i.focus(); }, 60);
}
function closeSearch() {
if (!searchModal || !searchModal.classList.contains('is-open')) return;
searchModal.classList.remove('is-open');
searchModal.setAttribute('aria-hidden', 'true');
if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
if (lastFocus && lastFocus.focus) lastFocus.focus();
}
document.addEventListener('click', function (e) {
if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
if (e.target.closest('[data-search-close]')) closeSearch();
});
var predictTimer;
document.addEventListener('input', function (e) {
if (!e.target.matches('[data-predictive-input]')) return;
var q = e.target.value.trim();
var out = $('[data-predictive-results]');
clearTimeout(predictTimer);
if (q.length < 2) { out.innerHTML = ''; return; }
predictTimer = setTimeout(function () {
var url = (D.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
fetch(url).then(function (r) { return r.json(); }).then(function (data) {
var items = (data.resources && data.resources.results && data.resources.results.products) || [];
if (!items.length) { out.innerHTML = '<p>No pieces match “' + escapeHtml(q) + '”.</p>'; return; }
var html = '<ul class="predict">' + items.map(function (p) {
var img = p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" loading="lazy">' : '';
return '<li><a href="' + p.url + '">' + img + '<span>' + escapeHtml(p.title) + '</span><br><span>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a></li>';
}).join('') + '</ul><a class="predict__all" href="' + D.routes.search + '?q=' + encodeURIComponent(q) + '&options[prefix]=last">See all results</a>';
out.innerHTML = html;
}).catch(function () { out.innerHTML = ''; });
}, 220);
});
function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function refreshCart(open) {
var drawer = $('#CartDrawer');
return fetch(D.routes.root.replace(/\/$/, '') + '/?section_id=cart-drawer')
.then(function (r) { return r.text(); })
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var fresh = $('[data-cart-inner]', doc);
var cur = $('[data-cart-inner]');
if (fresh && cur) cur.innerHTML = fresh.innerHTML;
var count = fresh ? parseInt(fresh.getAttribute('data-count'), 10) : 0;
$$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
if (drawer) drawer.classList.remove('is-loading');
if (open && drawer) openDrawer(drawer);
});
}
function addToCart(form) {
var btn = $('[type="submit"]', form);
var err = $('[data-form-error]', form);
if (err) err.hidden = true;
if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
return fetch(D.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
.then(function (res) {
if (!res.ok) throw new Error(res.data.description || res.data.message || 'This piece couldn’t be added.');
if (!$('#CartDrawer')) { window.location.href = D.routes.cart; return; }
return refreshCart(true);
})
.catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } else { toast(e.message); } })
.then(function () { if (btn) { btn.removeAttribute('aria-busy'); if (!btn.hasAttribute('data-sold-out')) btn.disabled = false; } });
}
document.addEventListener('submit', function (e) {
var form = e.target.closest('[data-product-form]');
if (!form || !window.fetch) return;
e.preventDefault();
addToCart(form);
});
document.addEventListener('click', function (e) {
var b = e.target.closest('#CartDrawer [data-line]');
if (!b) return;
var drawer = $('#CartDrawer');
drawer.classList.add('is-loading');
fetch(D.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: parseInt(b.dataset.qty, 10) }) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) toast(j.description || j.message || 'Not enough stock'); }); })
.then(function () { return refreshCart(false); })
.catch(function () { drawer.classList.remove('is-loading'); });
});
var autoTimer;
document.addEventListener('change', function (e) {
var el = e.target.closest('[data-autosubmit]');
if (!el) return;
var form = el.form || el.closest('form');
if (!form) return;
var inDrawer = el.closest('.drawer--filters');
if (inDrawer && window.matchMedia('(max-width: 989px)').matches) return;
clearTimeout(autoTimer);
autoTimer = setTimeout(function () { form.submit(); }, el.type === 'number' ? 500 : 0);
});
document.addEventListener('click', function (e) {
var s = e.target.closest('[data-qty-step]');
if (!s) return;
var input = $('input', s.parentNode);
var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(s.dataset.qtyStep, 10));
input.value = v;
});
D.formatMoney = formatMoney;
D.addToCart = addToCart;
})();